import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const EarlyAccess: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--early-access')}
    viewBox="0 0 19 28"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g transform="translate(-29 -323)" fill="none" fillRule="evenodd">
      <g transform="translate(18 317)">
        <g fill="#000" fillRule="nonzero">
          <path d="M24.911 17.105a34.933 34.933 0 00-8.039-.09v-2.282c0-2.435 1.782-4.415 3.97-4.415 2.144 0 3.886 1.871 3.96 4.257l.01.361h3.876v-.762c0-4.45-3.52-8.073-7.846-8.073-4.326 0-7.845 3.623-7.845 8.073V17.5l-1.837.233v15.434l3.589.456a45.53 45.53 0 005.747.361c1.92 0 3.841-.119 5.747-.361l3.588-.456V17.733l-4.92-.629zm-11.172-2.93c0-4.04 3.188-7.332 7.103-7.332 3.916 0 7.104 3.287 7.104 7.331l-2.426.02c-.247-2.614-2.242-4.613-4.683-4.613-2.598 0-4.712 2.311-4.712 5.157V17.1c-.015 0-.035.004-.05.004l-2.341.298v-3.228h.005zm15.35 18.339l-2.94.376a44.97 44.97 0 01-11.301 0l-2.94-.376V18.387l4.271-.545a34.124 34.124 0 018.643 0l4.272.545v14.127h-.005z" />
          <path d="M20.496 20.594a2.612 2.612 0 00-2.609 2.609c0 .916.47 1.747 1.243 2.222v4.223h2.732v-4.223a2.609 2.609 0 00-1.366-4.831zm.831 4.282l-.208.104v3.93h-1.247v-3.93l-.208-.104a1.867 1.867 0 01.827-3.54c1.03 0 1.866.837 1.866 1.867a1.83 1.83 0 01-1.03 1.673z" />
        </g>
      </g>
    </g>
  </svg>
);

export default EarlyAccess;
